<template>
    <div class="form-group">
        <span v-if="required" class="text-danger">*</span>
        <label :for="$attrs.id">
            {{label}}
        </label>
        <b-form-datepicker class="form-control"
                           v-if="!disabled" :id="$attrs.id" :placeholder="$attrs.placeholder||label" v-bind:value="value" @input="$emit('input', $event)"
                           :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" label-help="" reset-button />
        <span class="form-control" v-else>{{value|date('yyyy/mm/dd')}}</span>
    </div>
</template>

<script>
    export default {
        name: 'formDateInput',
        inheritAttrs: false,
        props: ['value', 'label'],
        computed: {
            required: function () {
                return this.$attrs.required === "" || this.$attrs.required === true;
            },
            disabled: function () {
                return this.$attrs.disabled === "" || this.$attrs.disabled === true;
            }
        },
    };
</script>

<style>
</style>